/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CategoryOverviewDto
 */
export interface CategoryOverviewDto {
    /**
     * 
     * @type {string}
     * @memberof CategoryOverviewDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CategoryOverviewDto
     */
    code: string | null;
    /**
     * 
     * @type {number}
     * @memberof CategoryOverviewDto
     */
    totalOrderCount: number;
    /**
     * 
     * @type {number}
     * @memberof CategoryOverviewDto
     */
    totalOrderAmount: number;
    /**
     * 
     * @type {string}
     * @memberof CategoryOverviewDto
     */
    description: string | null;
}

/**
 * Check if a given object implements the CategoryOverviewDto interface.
 */
export function instanceOfCategoryOverviewDto(value: object): value is CategoryOverviewDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('code' in value) || value['code'] === undefined) return false;
    if (!('totalOrderCount' in value) || value['totalOrderCount'] === undefined) return false;
    if (!('totalOrderAmount' in value) || value['totalOrderAmount'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    return true;
}

export function CategoryOverviewDtoFromJSON(json: any): CategoryOverviewDto {
    return CategoryOverviewDtoFromJSONTyped(json, false);
}

export function CategoryOverviewDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CategoryOverviewDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'code': json['code'],
        'totalOrderCount': json['totalOrderCount'],
        'totalOrderAmount': json['totalOrderAmount'],
        'description': json['description'],
    };
}

export function CategoryOverviewDtoToJSON(json: any): CategoryOverviewDto {
    return CategoryOverviewDtoToJSONTyped(json, false);
}

export function CategoryOverviewDtoToJSONTyped(value?: CategoryOverviewDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'code': value['code'],
        'totalOrderCount': value['totalOrderCount'],
        'totalOrderAmount': value['totalOrderAmount'],
        'description': value['description'],
    };
}

